import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import Link from "next/link";
import { checkEmailExists } from "@/data/lib";
import Spinner from "@/utilities/Loader/index1";

const Quiz1 = () => {
  const [showModal, setShowModal] = useState(true);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const [startLoader, setStartLoader] = useState(false);

  useEffect(() => {
    localStorage.removeItem("quizAnswers");
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  const handleSubmit = async () => {
    setError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setError(" Please enter a valid email address.");
      return;
    }

    try {
      setLoader(true);
      const response = await checkEmailExists(email);

      if (response.success === false && response.error === true) {
        setError(response.message);
        setLoader(false);
        return;
      }

      localStorage.setItem("quiz_user_email", email);
      sessionStorage.setItem("cameFromQuiz", "true");
      setShowModal(false);
      setLoader(false);
    } catch (err) {
      console.error(err);
      setError(" Failed to verify email. Please try again.");
      setLoader(false);
    }
  };

  const handleStartNow = () => {
    setStartLoader(true);
    setTimeout(() => {
      window.location.href = "/quizstart";
    }, 500);
  };

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.Quiz1Main} ${showModal ? styles.blur : ""}`}>
        <div className={styles.Quiz1Img}>
          <img src="/images/Longevity.webp" alt="Longevity" />
        </div>

        <div className={styles.Content}>
          <h2>Mediterranean Longevity Quiz</h2>
          <p className={styles.subHeading}>
            Ready to live longer, feel better, and embrace the Mediterranean
            way? <br />
            Discover your personalized path to Mediterranean wellness. Answer a
            few quick questions to get tailored Bruno MD Product recommendations
            and lifestyle tips that match your unique health and wellness goals.
          </p>

          <button
            className={styles.StartBtn}
            onClick={handleStartNow}
            disabled={startLoader}
          >
            <p>{startLoader ? <Spinner /> : "START NOW"}</p>
          </button>

          <div className={styles.description}>
            <p>
              By clicking start and taking our Wellness Quiz, you understand and
              agree that some of the information you provide may include health
              data and will be subject to our{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy.
              </a>{" "}
              You can withdraw your consent at any time.
            </p>
          </div>
        </div>
      </div>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <Link href="/">
              <button className={styles.backBtn}>
                <img src="/images/BackBtn.png" alt="BackBtn" />
              </button>
            </Link>

            <p className={styles.message}>
              Take the Quiz & Start Feeling Your Best
            </p>

            <h3 className={styles.off}>
              Answer a few quick questions to get personalized health tips made
              just for you.
            </h3>

            <p className={styles.descP}>As a thank you, you’ll get:</p>
            <p className={styles.descP2}>
              <li>30 days of extra savings</li>
              <li>20% + an extra 10% off your first subscription</li>
              <li>Lifetime 20% off all future subscription orders</li>
            </p>
            <input
              type="email"
              placeholder="Enter your Email to Proceed"
              className={styles.emailInput}
              value={email}
              onChange={(e) => {
                const val = e.target.value;
                setEmail(val);

                if (val.trim() === "") {
                  setError("");
                }
              }}
            />
            {error && <div className={styles.error}>{error}</div>}

            <button
              onClick={handleSubmit}
              className={styles.submitBtn}
              disabled={loader}
            >
              {loader ? <Spinner /> : "Let’s get started"}
            </button>

            <p className={styles.descP3}>
              Better health and great savings are just a quiz away!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz1;
Quiz1.hideQuiz = true;
